export const environment = {
  production: true,
  environmentName: 'test',
  apiGatewayURL: 'https://api.test.hero.schoolmint.com/hero-v1'
};
